import React from "react";
import { cn } from "../../../lib/utils";

/**
 * Page component - replaces styled Page component
 * Responsive layout that adjusts width based on screen size
 */
export const Page = ({ children, className = "" }) => {
  return (
    <div 
      className={cn(
        // Default desktop styles
        "w-[calc(100%-300px)] h-full relative",
        // Mobile and portrait styles - full width, flex column-reverse
        "mobile-max:w-full mobile-max:flex mobile-max:flex-col-reverse",
        "portrait:w-full portrait:flex portrait:flex-col-reverse",
        className
      )}
    >
      {children}
    </div>
  );
};

/**
 * PageContent component - replaces styled PageContent component
 * Contains the main content area with calculated height
 */
export const PageContent = ({ children, className = "" }) => {
  return (
    <div 
      className={cn(
        "relative h-[calc(100%-64px)] w-full",
        className
      )}
    >
      {children}
    </div>
  );
};
